import { availableCameras, projectEquipment } from '~/utils/projectCatalog';
import { projectText, type CameraKind } from '~/utils/project';
import { supportMonthlyPrice } from '~/utils/projectPricing';
import { formatPrice } from '~/utils/shop';
import { useEquipmentCatalog } from './useEquipmentCatalog';
import { useProjectPlanner } from './useProjectPlanner';

export function useProjectQuote() {
  const { project } = useProjectPlanner();
  const { data: products, pending, error, refresh } = useEquipmentCatalog();
  const quote = computed(() => projectEquipment(project.value, error.value ? [] : products.value));
  const price = computed(() =>
    pending.value
      ? 'Обновляем цены…'
      : error.value
        ? 'Цены недоступны'
        : quote.value.total === null
          ? 'Нужен подбор'
          : formatPrice(quote.value.total),
  );
  return {
    quote,
    price,
    servicePrice: computed(() => {
      const monthly = supportMonthlyPrice(project.value.cameras.length);
      return monthly === null ? 'По отдельному расчёту' : formatPrice(monthly) + ' / мес.';
    }),
    pending,
    error,
    refresh,
    storageLabel: computed(() =>
      project.value.includeArchive === false
        ? 'Без архива'
        : pending.value
          ? '…'
          : error.value
            ? 'Недоступно'
            : quote.value.storageTB > 0
              ? `${quote.value.storageTB} ТБ`
              : project.value.cameras.length
                ? 'Нужен подбор'
                : '0 ТБ',
    ),
    cameraOptions: (kind: CameraKind) => availableCameras(products.value, kind),
    text: () => projectText(project.value, pending.value || error.value ? undefined : quote.value),
  };
}
